import { HsRegularGeometryData } from '@sibe/hyperscene';

/** A signed distance function; points with a negative value are inside the shape. */
export type SignedDistanceFunction = (x: number, y: number, z: number) => number;

/**
 * Samples the inside of `distanceFunction` on a `side`³ grid over [-1, 1]³. Point colors follow the grid index
 * (red along x, green along y, blue along z) and sit where `hsMakeGeometry` puts normals, which is where point
 * clouds read their colors.
 */
export function makeSdfPointCloudData(side: number, distanceFunction: SignedDistanceFunction): HsRegularGeometryData {
  const positions: number[] = [];
  const colors: number[] = [];
  for (let i: number = 0; i < side; i++) {
    for (let j: number = 0; j < side; j++) {
      for (let k: number = 0; k < side; k++) {
        const x: number = (i / side) * 2 - 1;
        const y: number = (j / side) * 2 - 1;
        const z: number = (k / side) * 2 - 1;
        if (distanceFunction(x, y, z) < 0) {
          positions.push(x, y, z);
          colors.push(i / side, j / side, k / side);
        }
      }
    }
  }
  return new HsRegularGeometryData(positions, colors);
}
